import { FiltroConsultaReporteGlosas, RespuestaReporteGeneral, RespuestaReporteDetalle } from "../modelo/ReporteGlosasModelo";

export const CONSULTA_REPORTE_GENERAL = "CONSULTA_REPORTE_GENERAL";
export const EXITO_REPORTE_GENERAL = "EXITO_REPORTE_GENERAL";

export const CONSULTA_REPORTE_DETALLE = "CONSULTA_REPORTE_DETALLE";
export const EXITO_REPORTE_DETALLE = "EXITO_REPORTE_DETALLE";

export const ERROR_CONTROLADO_CONSULTA = "ERROR_CONTROLADO_CONSULTA";
export const ERROR_NO_CONTROLADO_CONSULTA = "ERROR_NO_CONTROLADO_CONSULTA";

export const DESCARGAR_XLS_REPORTE_GLOSAS = "DESCARGAR_XLS_REPORTE_GLOSAS";
export const EXITO_XLS_REPORTE_GLOSAS = "EXITO_XLS_REPORTE_GLOSAS";
export const ERROR_XLS_REPORTE_GLOSAS = "ERROR_XLS_REPORTE_GLOSAS";

export const LIMPIAR_MENSAJES_ERROR_REPORTE = "LIMPIAR_MENSAJES_ERROR_REPORTE";

export const consultarReporteGeneral = (filtro: FiltroConsultaReporteGlosas) => ({ type: CONSULTA_REPORTE_GENERAL, filtro });
export const consultaReporteDetalle = (filtro: FiltroConsultaReporteGlosas) => ({ type: CONSULTA_REPORTE_DETALLE, filtro });

export const exitoReporteGeneral = (datosRespuesta: Array<RespuestaReporteGeneral>) => ({ type: EXITO_REPORTE_GENERAL, datosRespuesta });
export const exitoReporteDetalle = (datosRespuesta: Array<RespuestaReporteDetalle>) => ({ type: EXITO_REPORTE_DETALLE, datosRespuesta });

export const errorControladoConsulta = (mensajeError: string) => ({ type: ERROR_CONTROLADO_CONSULTA, mensajeError });

export const descargarXlsReporteGlosas = (filtro: FiltroConsultaReporteGlosas) => ({ type: DESCARGAR_XLS_REPORTE_GLOSAS, filtro });
export const exitoXlsReporteGlosas = () => ({ type: EXITO_XLS_REPORTE_GLOSAS });
export const errorXlsReporteGlosas = (mensajeError: string) => ({ type: ERROR_XLS_REPORTE_GLOSAS, mensajeError});

export const errorNoControladoConsulta = () => ({ type: ERROR_NO_CONTROLADO_CONSULTA });
export const limpiarMensajesErrorReporte = () => ({type: LIMPIAR_MENSAJES_ERROR_REPORTE});




// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/reporte_glosas/modulos/ReporteGlosasActions.ts